import { render, staticRenderFns } from "./suporte-alterar-situacao-solicitacao.vue?vue&type=template&id=ed5c1fd2&scoped=true"
import script from "./suporte-alterar-situacao-solicitacao.vue?vue&type=script&lang=ts"
export * from "./suporte-alterar-situacao-solicitacao.vue?vue&type=script&lang=ts"
import style0 from "./suporte-alterar-situacao-solicitacao.vue?vue&type=style&index=0&id=ed5c1fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5c1fd2",
  null
  
)

export default component.exports